import React from 'react';
import { X, Plus } from 'lucide-react';
import { StandardIngredient } from '../../types/ingredients';

interface AddAliasModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  extractedName: string;
  selectedIngredient: StandardIngredient;
}

export const AddAliasModal: React.FC<AddAliasModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  extractedName,
  selectedIngredient
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex min-h-screen items-center justify-center p-4">
        {/* Backdrop */}
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 transition-opacity"
          onClick={onClose}
        />

        {/* Modal */}
        <div className="relative bg-white rounded-lg shadow-xl max-w-md w-full p-6">
          {/* Close button */}
          <button
            onClick={onClose}
            className="absolute top-4 right-4 text-gray-400 hover:text-gray-600"
          >
            <X className="h-5 w-5" />
          </button>

          {/* Icon */}
          <div className="flex items-center justify-center w-12 h-12 bg-blue-100 rounded-full mb-4">
            <Plus className="h-6 w-6 text-blue-600" />
          </div>

          {/* Content */}
          <h3 className="text-lg font-semibold text-gray-900 mb-2">
            Ajouter comme alias ?
          </h3>
          
          <p className="text-sm text-gray-600 mb-4">
            Voulez-vous ajouter <span className="font-semibold text-gray-900">"{extractedName}"</span> comme alias 
            de l'ingrédient <span className="font-semibold text-gray-900">"{selectedIngredient.name}"</span> ?
          </p>

          <div className="bg-blue-50 border border-blue-200 rounded-lg p-3 mb-4">
            <p className="text-xs text-blue-800">
              💡 Cela permettra au système de reconnaître automatiquement ce terme lors des prochaines extractions.
            </p>
          </div>

          {/* Existing aliases preview */}
          {selectedIngredient.aliases && selectedIngredient.aliases.length > 0 && (
            <div className="mb-4">
              <p className="text-xs font-medium text-gray-700 mb-1">Alias existants :</p>
              <div className="flex flex-wrap gap-1">
                {selectedIngredient.aliases.map((alias, index) => (
                  <span key={index} className="text-xs px-2 py-1 bg-gray-100 rounded">
                    {alias}
                  </span>
                ))}
              </div>
            </div>
          )}

          {/* Actions */}
          <div className="flex gap-3">
            <button
              onClick={onClose}
              className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 font-medium rounded-lg hover:bg-gray-50 transition-colors"
            >
              Non, merci
            </button>
            <button
              onClick={onConfirm}
              className="flex-1 px-4 py-2 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 transition-colors"
            >
              Oui, ajouter
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

